(()=>{if(customElements.get('foxinnov-configurator'))return;let count=0;class FoxConfigurator extends HTMLElement{connectedCallback(){if(this.initialized)return;this.initialized=true;const root=this;const thisId=++count;const byId=id=>root.querySelector('#'+id);

const MIN_QTY = 30;
const state = { type:'pvc', shape:'rond', L:85, W:85, qty:50, color:'#17191c', previewUrl:null, numbering:false, phospho:false, cordura:false, filOr:false, libreDesc:'', visualMode:null, visualNote:'', fileName:null, file:null, nom:'', prenom:'', tel:'', email:'', adresse:'', commentaire:'' };
const PRICE_TIERS = [
  { min:30,  max:49,  bt:6.17, pvc:8.27, laser:null },
  { min:50,  max:99,  bt:4.96, pvc:5.44, laser:5.92 },
  { min:100, max:199, bt:2.98, pvc:3.86, laser:5.41 },
  { min:200, max:299, bt:2.19, pvc:3.25, laser:5.18 },
  { min:300, max:499, bt:2.02, pvc:2.77, laser:4.51 },
  { min:500, max:Infinity, bt:1.90, pvc:2.29, laser:3.67 }
];
const UV_PRICE_TIERS = [
  { min:1,   max:1,        price:14.99 },
  { min:2,   max:4,        price:12.50 },
  { min:5,   max:9,        price:11.00 },
  { min:10,  max:24,       price:10.27 },
  { min:25,  max:49,       price:8.95 },
  { min:50,  max:99,       price:6.07 },
  { min:100, max:Infinity, price:4.09 }
];
const NUMBERING_SURCHARGE = 1;
const CONTACT_EMAIL = 'contact@foxinnov.fr';
const DELAI_STANDARD = '3 à 4 semaines après validation du maquettage';
const DELAI_UV = '7 à 14 jours après validation de l\'échantillon';

function minQtyFor(){ return state.type === 'uv' ? 1 : MIN_QTY; }
function getDelaiLabel(){ return state.type === 'uv' ? DELAI_UV : DELAI_STANDARD; }

// --- Configuration Forminit ---
const FORMINIT_FORM_ID = 'odx4c00gk7z';


function priceColumn(){
  return (state.type==='brode' || state.type==='tisse') ? 'bt' : state.type;
}

function getPricing(){
  if(!Number.isInteger(state.qty) || state.qty < minQtyFor()) return null;
  if(state.type === 'uv'){
    const uvTier = UV_PRICE_TIERS.find(t => state.qty >= t.min && state.qty <= t.max);
    if(!uvTier) return { unavailable:true, uv:true };
    const unit = uvTier.price;
    const total = unit * state.qty;
    return { base:uvTier.price, pct:0, basePlusOptions:uvTier.price, numSurcharge:0, unit, total, qty:state.qty };
  }
  const tier = PRICE_TIERS.find(t => state.qty >= t.min && state.qty <= t.max);
  if(!tier) return null;
  const base = tier[priceColumn()];
  if(base === null || base === undefined) return { unavailable:true };

  let pct = 0;
  if(state.type==='pvc' && state.phospho) pct += 0.10;
  if(state.type==='brode' && state.cordura) pct += 0.05;
  if(state.type==='brode' && state.filOr) pct += 0.05;
  const basePlusOptions = base * (1 + pct);

  const numSurcharge = state.numbering ? NUMBERING_SURCHARGE : 0;
  const unit = basePlusOptions + numSurcharge;
  const total = unit * state.qty;
  return { base, pct, basePlusOptions, numSurcharge, unit, total, qty: state.qty };
}

function formatEUR(n){
  return n.toLocaleString('fr-FR', { minimumFractionDigits:2, maximumFractionDigits:2 }) + ' € TTC';
}
const shapeLabels = { rond:'Rond', carre:'Carré', rectangle:'Rectangle', ecu:'Écu', libre:'Forme libre' };
const visualLabels = { pret:'Prêt, sans modification', ia:'Généré par IA, à adapter à la production (supplément possible)', modif:'À modifier (prix selon le travail)', creation:'À créer (prestation sur devis)' };
const visualShort = { pret:'Prêt', ia:'IA, à adapter', modif:'À modifier', creation:'À créer' };
const typeLabels = { brode:'Brodé', tisse:'Tissé', pvc:'PVC', laser:'Laser Cut', uv:'Écusson impression UV', cuir:'Cuir' };

root.querySelectorAll('.type-tile').forEach(tile=>{
  tile.addEventListener('click', ()=>{
    if(tile.classList.contains('type-tile-disabled')) return;
    root.querySelectorAll('.type-tile').forEach(t=>t.classList.remove('active'));
    tile.classList.add('active');
    state.type = tile.dataset.type;

    byId('pvcOptions').style.display = state.type==='pvc' ? 'block' : 'none';
    byId('brodeOptions').style.display = state.type==='brode' ? 'block' : 'none';
    byId('numOptionWrap').style.display = state.type==='pvc' ? 'block' : 'none';
    if(state.type!=='pvc'){
      state.phospho = false; byId('phosphoOption').checked = false;
      state.numbering = false; byId('numOption').checked = false;
    }
    if(state.type!=='brode'){
      state.cordura = false; byId('corduraOption').checked = false;
      state.filOr = false; byId('filOrOption').checked = false;
    }

    const isUv = state.type === 'uv';
    if (byId('uvDirectOrder')) byId('uvDirectOrder').hidden = !isUv;
    byId('shapeStep').style.display = isUv ? 'none' : '';
    byId('sizeFields').style.display = isUv ? 'none' : '';
    byId('uvSizeChoice').style.display = isUv ? 'block' : 'none';
    byId('sizeHelp').textContent = isUv
      ? 'Deux formats disponibles pour l\'impression UV.'
      : 'Indiquez les dimensions souhaitées, en millimètres.';
    byId('qtyHelp').textContent = isUv
      ? 'Commande minimum : 1 pièce.'
      : 'Commande minimum : 30 pièces.';
    byId('qtyCustom').min = isUv ? 1 : MIN_QTY;
    byId('qtyCustom').placeholder = isUv ? 'min. 1' : 'min. 30';
    byId('qtyWarnMin').textContent = isUv ? '1' : '30';

    if(isUv){
      root.querySelectorAll('#uvSizeChoice .shape-tile').forEach(t=>t.classList.remove('active'));
      const def = root.querySelector('#uvSizeChoice [data-uvsize="rond85"]');
      if(def){ def.classList.add('active'); }
      state.shape = 'rond'; state.L = 85; state.W = 85;
    }

    byId('tailleL').value=state.L || ''; byId('tailleW').value=state.W || '';
    const warn = byId('qtyWarn');
    warn.classList.toggle('show', state.qty!==null && state.qty < minQtyFor());

    update();
  });
});

root.querySelectorAll('#uvSizeChoice [data-uvsize]').forEach(tile=>{
  tile.addEventListener('click', ()=>{
    root.querySelectorAll('#uvSizeChoice .shape-tile').forEach(t=>t.classList.remove('active'));
    tile.classList.add('active');
    if(tile.dataset.uvsize === 'rond85'){ state.shape='rond'; state.L=85; state.W=85; }
    else { state.shape='rectangle'; state.L=90; state.W=65; }
    update();
  });
});

root.querySelectorAll('#shapeTiles .shape-tile').forEach(tile=>{
  tile.addEventListener('click', ()=>{
    root.querySelectorAll('#shapeTiles .shape-tile').forEach(t=>t.classList.remove('active'));
    tile.classList.add('active');
    state.shape = tile.dataset.shape;
    byId('sizeLibreDesc').style.display = state.shape==='libre' ? 'block' : 'none';
    update();
  });
});

byId('tailleL').addEventListener('input', e=>{ state.L = e.target.value?+e.target.value:null; update(); });
byId('tailleW').addEventListener('input', e=>{ state.W = e.target.value?+e.target.value:null; update(); });
byId('libreDesc').addEventListener('input', e=>{ state.libreDesc = e.target.value; update(); });

byId('qtyCustom').addEventListener('input', e=>{
  state.qty = e.target.value?+e.target.value:null;
  const warn = byId('qtyWarn');
  warn.classList.toggle('show', state.qty!==null && state.qty < minQtyFor());
  update();
});

byId('numOption').addEventListener('change', e=>{ state.numbering = e.target.checked; update(); });
byId('phosphoOption').addEventListener('change', e=>{ state.phospho = e.target.checked; update(); });
byId('corduraOption').addEventListener('change', e=>{ state.cordura = e.target.checked; update(); });
byId('filOrOption').addEventListener('change', e=>{ state.filOr = e.target.checked; update(); });

byId('ctNom').addEventListener('input', e=>{ state.nom = e.target.value; update(); });
byId('ctPrenom').addEventListener('input', e=>{ state.prenom = e.target.value; update(); });
byId('ctTel').addEventListener('input', e=>{ state.tel = e.target.value; update(); });
byId('ctEmail').addEventListener('input', e=>{ state.email = e.target.value; update(); });
byId('ctAdresse').addEventListener('input', e=>{ state.adresse = e.target.value; update(); });
byId('ctCommentaire').addEventListener('input', e=>{ state.commentaire = e.target.value; update(); });

// Visuel : état du fichier (étape 2)
root.querySelectorAll('input[name="fxVisualMode"]').forEach(r=>r.addEventListener('change',()=>{
  state.visualMode=r.value;
  const noteWrap=byId('fxVisualNoteWrap'),noteLabel=byId('fxVisualNoteLabel'),note=byId('fxVisualNote');
  noteWrap.hidden=!['ia','modif','creation'].includes(state.visualMode);
  if(state.visualMode==='ia'){noteLabel.textContent='Précisions sur votre visuel (facultatif)';note.placeholder='Ex. : garder le loup et la devise, simplifier le fond…';}
  if(state.visualMode==='modif'){noteLabel.textContent='Décrivez les modifications souhaitées';note.placeholder='Ex. : remplacer le texte par « PSIG 44 », passer le fond en kaki, retirer le dégradé…';}
  if(state.visualMode==='creation'){noteLabel.textContent='Décrivez votre idée';note.placeholder='Ex. : un renard de profil, la devise de l’unité en bas, couleurs bleu marine et or…';}
  byId('fxUploadStep').hidden=false;
  byId('fxUploadTitle').textContent=state.visualMode==='creation'?'Croquis ou image d’inspiration (facultatif)':'Votre fichier';
  byId('fxUploadHint').hidden=state.visualMode==='creation';
  showError('');update();
}));
byId('fxVisualNote').addEventListener('input',e=>{state.visualNote=e.target.value;update();});

// Dropzone
const dropzone = byId('dropzone');
const fileInput = byId('fileInput');
dropzone.addEventListener('click', ()=>fileInput.click());
dropzone.addEventListener('dragover', e=>{ e.preventDefault(); dropzone.classList.add('drag'); });
dropzone.addEventListener('dragleave', ()=>dropzone.classList.remove('drag'));
dropzone.addEventListener('drop', e=>{
  e.preventDefault(); dropzone.classList.remove('drag');
  if(e.dataTransfer.files && e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]);
});
fileInput.addEventListener('change', e=>{
  if(e.target.files && e.target.files[0]) handleFile(e.target.files[0]);
});

function handleFile(file){
  if(file.size > 10 * 1024 * 1024){showError('Le fichier dépasse 10 Mo.'); return;}
  if(!/\.(png|jpe?g|webp|pdf|ai|eps)$/i.test(file.name)){showError('Choisissez un fichier PNG, JPG, WebP, PDF, AI ou EPS.');return;}
  showError(''); state.fileName=file.name; state.file=file; state.previewUrl=null;
  const doc=window.document;
  const wrap=byId('filePreviewWrap');wrap.replaceChildren();
  const title=doc.createElement('div');title.className='fxc-visual-title';title.textContent='Votre visuel';
  const stageBox=doc.createElement('div');stageBox.className='fxc-visual-box';
  const replace=doc.createElement('button');replace.type='button';replace.className='fxc-replace';
  replace.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 11a8 8 0 0 0-14.3-4.9L4 8"/><path d="M4 3v5h5"/><path d="M4 13a8 8 0 0 0 14.3 4.9L20 16"/><path d="M20 21v-5h-5"/></svg>Remplacer';
  replace.addEventListener('click',()=>fileInput.click());
  const ext=(file.name.split('.').pop()||'').toUpperCase();
  const ph=doc.createElement('div');ph.className='fxc-file-ph';ph.textContent=ext;
  stageBox.append(replace,ph);
  const row=doc.createElement('div');row.className='file-preview';
  const ok=doc.createElement('span');ok.className='fp-ok';ok.setAttribute('aria-hidden','true');ok.innerHTML='<svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  const info=doc.createElement('span');info.className='fp-info';
  const status=doc.createElement('b');status.textContent='Fichier chargé avec succès';
  const label=doc.createElement('span');label.className='fp-name';label.textContent=file.name+' – '+(file.size>=1048576?(file.size/1048576).toFixed(1).replace('.',',')+' Mo':Math.max(1,Math.round(file.size/1024))+' Ko');
  info.append(status,label);
  const remove=doc.createElement('button');remove.type='button';remove.className='fp-remove';remove.id='fpRemove';
  remove.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>Supprimer';
  row.append(ok,info,remove);wrap.append(title,stageBox,row);
  root.classList.add('has-file');
  remove.addEventListener('click',()=>{state.fileName=null;state.file=null;state.previewUrl=null;fileInput.value='';wrap.replaceChildren();root.classList.remove('has-file');update();});
  if(/\.(png|jpe?g|webp)$/i.test(file.name)){
    const reader=new FileReader();reader.onload=()=>{if(state.file===file){state.previewUrl=reader.result;const preview=doc.createElement('img');preview.src=state.previewUrl;preview.alt='Aperçu de votre visuel';preview.className='fxc-upload-preview';ph.replaceWith(preview);update();}};reader.readAsDataURL(file);
  }
  fileInput.value='';
  update();
}

function sizeLabel(){
  return (state.L && state.W) ? (state.L + ' × ' + state.W + ' mm') : '—';
}

function update() {
  syncPreview();
  byId('infoType').textContent = typeLabels[state.type];
  byId('infoShape').textContent = shapeLabels[state.shape];
  byId('infoSize').textContent = sizeLabel();
  byId('infoFile').textContent = state.fileName || 'Non joint';
  byId('infoVisual').textContent = state.visualMode ? visualShort[state.visualMode] : 'À préciser';
  byId('infoQty').textContent = state.qty ? state.qty + (state.qty === 1 ? ' pièce' : ' pièces') : 'À renseigner';
  byId('infoNumRow').hidden = state.type !== 'pvc';
  byId('infoNum').textContent = state.numbering ? 'Oui' : 'Non';
  byId('infoDelai').textContent = getDelaiLabel();
  byId('delaiText').textContent = 'Délai de fabrication : ' + getDelaiLabel();

  byId('infoPhosphoRow').style.display = state.type==='pvc' ? 'flex' : 'none';
  byId('infoPhospho').textContent = state.phospho ? 'Oui (+10%)' : 'Non';
  byId('infoCorduraRow').style.display = state.type==='brode' ? 'flex' : 'none';
  byId('infoCordura').textContent = state.cordura ? 'Oui (+5%)' : 'Non';
  byId('infoFilOrRow').style.display = state.type==='brode' ? 'flex' : 'none';
  byId('infoFilOr').textContent = state.filOr ? 'Oui (+5%)' : 'Non';

  renderPatch();
  updateRecap();
  if(['ia','modif','creation'].includes(state.visualMode)){const pn=byId('priceNote');if(pn&&!/visuel chiffr/.test(pn.textContent))pn.textContent+=' Travail sur le visuel chiffré en plus sur le devis.';}
}

function updateRecap(){
  const copyBtn = byId('copyBtn');
  const belowMin = state.qty !== null && (!Number.isInteger(state.qty) || state.qty < minQtyFor());
  const ta = byId('recapText');

  if(belowMin){
    ta.value = 'Quantité minimum de commande : ' + minQtyFor() + ' pièce' + (minQtyFor()>1?'s':'') + '.\nMerci d\'ajuster la quantité pour générer votre demande.';
    copyBtn.disabled = true;
    byId('sendBtn').disabled = true;
    byId('priceUnit').textContent = '—';
    byId('priceTotal').textContent = '—';
    byId('priceNote').textContent = 'Quantité minimum : ' + minQtyFor() + ' pièce' + (minQtyFor()>1?'s':'') + '.';
    return;
  }
  copyBtn.disabled = false;
  byId('sendBtn').disabled = sending;

  let lines = [];
  lines.push('DEMANDE DE DEVIS — ÉCUSSON FOXINNOV');
  lines.push('Cette demande n\'engage à rien. Notre équipe reviendra vers vous sous 48h ouvrées pour vous proposer un devis.');
  lines.push('');
  lines.push('COORDONNÉES');
  lines.push('Nom : ' + (state.nom.trim() || '—'));
  lines.push('Prénom : ' + (state.prenom.trim() || '—'));
  lines.push('Téléphone : ' + (state.tel.trim() || '—'));
  lines.push('E-mail : ' + (state.email.trim() || '—'));
  lines.push('Adresse : ' + (state.adresse.trim() || '—'));
  lines.push('');
  lines.push('DÉTAILS DE LA DEMANDE');
  lines.push('Modèle souhaité : ' + typeLabels[state.type]);
  lines.push('Forme : ' + shapeLabels[state.shape]);
  if(state.shape==='libre' && state.libreDesc.trim()){
    lines.push('Description de la forme : ' + state.libreDesc.trim());
  }
  lines.push('Taille (Longueur × Largeur) : ' + sizeLabel());
  lines.push('Visuel : ' + (state.visualMode ? visualLabels[state.visualMode] : 'non précisé'));
  if(state.visualNote.trim()) lines.push((state.visualMode==='creation'?'Idée de visuel : ':'Précisions sur le visuel : ') + state.visualNote.trim());
  lines.push('Fichier joint : ' + (state.fileName ? state.fileName : 'aucun'));
  lines.push('Quantité : ' + (state.qty ? state.qty + ' pièces' : '—'));
  if(state.type==='pvc'){
    lines.push('Phosphorescent : ' + (state.phospho ? 'Oui (+10%)' : 'Non'));
  }
  if(state.type==='brode'){
    lines.push('Cordura : ' + (state.cordura ? 'Oui (+5%)' : 'Non'));
    lines.push('Fil d\'or et/ou argent : ' + (state.filOr ? 'Oui (+5%)' : 'Non'));
  }
  if(state.type==='pvc'){
    lines.push('Numérotation individuelle : ' + (state.numbering ? 'Oui, souhaitée (+' + NUMBERING_SURCHARGE.toFixed(2).replace('.',',') + ' € / pièce)' : 'Non'));
  }
  lines.push('Fixation : scratch (velcro) cousu à l\'arrière — inclus');
  lines.push('Délai de fabrication estimé : ' + getDelaiLabel());
  lines.push('');

  const pricing = getPricing();
  byId('priceBox').style.display = 'block';
  if(!pricing){
    byId('priceUnit').textContent = '—';
    byId('priceTotal').textContent = '—';
    byId('priceNote').textContent = 'Renseignez la quantité pour afficher l\'estimation.';
  } else if(pricing.unavailable){
    byId('priceUnit').textContent = 'Sur devis';
    byId('priceTotal').textContent = 'Sur devis';
    if(pricing.uv){
      byId('priceNote').textContent = 'Tarif Impression UV établi sur devis selon quantité, disponible dès 1 pièce.';
      lines.push('Estimation tarifaire : sur devis (Impression UV, disponible dès 1 pièce)');
    } else {
      byId('priceNote').textContent = 'Ce tarif Laser Cut n\'est disponible qu\'à partir de 50 pièces. En dessous, le prix est établi sur devis.';
      lines.push('Estimation tarifaire : sur devis (Laser Cut indisponible en dessous de 50 pièces à ce tarif)');
    }
  } else {
    byId('priceUnit').textContent = formatEUR(pricing.unit);
    byId('priceTotal').textContent = '≈ ' + formatEUR(pricing.total);
    byId('priceNote').textContent = 'Tarifs TTC indicatifs hors frais de port, pouvant évoluer selon la complexité du visuel.';
    lines.push('Prix par pièce estimé : ' + formatEUR(pricing.unit) + (state.numbering ? ' (dont ' + NUMBERING_SURCHARGE.toFixed(2).replace('.',',') + ' € de numérotation)' : ''));
    lines.push('Total estimé : ' + formatEUR(pricing.total));
    lines.push('(Tarifs TTC indicatifs hors frais de port, susceptibles d\'évoluer selon la complexité du visuel)');
  }

  if(state.commentaire.trim()){
    lines.push('');
    lines.push('Commentaire : ' + state.commentaire.trim());
  }

  ta.value = lines.join('\n');
}

byId('copyBtn').addEventListener('click', ()=>{
  const ta = byId('recapText');
  ta.select();
  if(!navigator.clipboard){ showError('Sélectionnez le récapitulatif pour le copier manuellement.'); return; }
  navigator.clipboard.writeText(ta.value).then(()=>{
    const btn = byId('copyBtn');
    const original = btn.textContent;
    btn.textContent = 'Copié ✓';
    btn.classList.add('copied');
    btn.classList.remove('is-sending');
    setTimeout(()=>{ btn.textContent = original; btn.classList.remove('copied'); }, 1800);
  }).catch(()=>showError('La copie automatique est indisponible. Copiez le récapitulatif manuellement.'));
});

function normalizePhoneFR(raw){
  const digits = (raw || '').replace(/[^\d+]/g, '');
  if(!digits) return '';
  if(digits.charAt(0) === '+') return digits;
  if(digits.indexOf('0033') === 0) return '+33' + digits.slice(4);
  if(digits.charAt(0) === '0') return '+33' + digits.slice(1);
  return digits;
}

let sending=false;
byId('sendBtn').addEventListener('click', async ()=>{
  if(sending || !validateConfiguration() || !validateContact()) return;
  const forminitClient = (typeof window.Forminit !== 'undefined') ? new window.Forminit() : null;
  const body = byId('recapText').value;
  const btn = byId('sendBtn');
  const noteEl = root.querySelector('.recap-actions .recap-note');
  const noteOriginal = noteEl ? noteEl.textContent : '';
  const labelEl = btn.querySelector(".fxc-send-label") || btn;
  const original = labelEl.textContent;

  if(!forminitClient){
    // Repli : mailto (aucune pièce jointe possible via mailto)
    const subject = 'Demande de devis écusson — ' + typeLabels[state.type];
    const mailto = 'mailto:' + CONTACT_EMAIL + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
    if(noteEl) noteEl.textContent = 'Votre messagerie va s’ouvrir. Joignez votre fichier manuellement avant l’envoi.';
    window.location.href = mailto;
    return;
  }

  sending=true;btn.classList.add('is-sending');
  labelEl.textContent = 'Envoi en cours…';
  btn.disabled = true;
  try{
    const fd = new FormData();
    fd.append('fi-sender-firstName', state.prenom.trim());
    fd.append('fi-sender-lastName', state.nom.trim());
    fd.append('fi-sender-email', state.email.trim());
    fd.append('fi-sender-phone', normalizePhoneFR(state.tel));
    fd.append('fi-sender-address', state.adresse.trim());
    fd.append('fi-text-message', body);
    if(state.file){
      fd.append('fi-file-attachments[]', state.file, state.fileName);
    }
    const { data, error } = await forminitClient.submit(FORMINIT_FORM_ID, fd);
    if(error){ throw new Error(error.message || 'Échec Forminit'); }
    btn.classList.remove('is-sending');
    flyPlane(btn);
    btn.classList.add('is-sent');
    labelEl.textContent = 'Demande de devis envoyée';
    if(noteEl) noteEl.textContent='Votre demande a bien été envoyée à FOXINNOV.';
  } catch(err){
    console.error('Échec envoi Forminit :', err);
    btn.classList.remove('is-sending');
    labelEl.textContent = 'Échec — réessayez';
    if(noteEl) noteEl.textContent = 'Erreur : ' + (err && err.message ? err.message : 'échec inconnu');
  } finally {
    setTimeout(()=>{
      sending=false;btn.classList.remove('is-sent','is-sending','is-flown');
      labelEl.textContent = original;
      btn.disabled = false;
      if(noteEl) noteEl.textContent = noteOriginal;
    }, 4000);
  }
});


let currentStep=1,face='front';
function showError(message){byId('fxError').textContent=message;}
function validateConfiguration(){
 const minimum=minQtyFor();
 const quantity=byId('qtyCustom');
 if(!quantity.value.trim()){showError('Renseignez la quantité souhaitée pour continuer.');quantity.focus();return false;}
 state.qty=Number(quantity.value);
 if(!Number.isInteger(state.qty)||state.qty<minimum){showError('Indiquez une quantité entière d’au moins '+minimum+' pièce(s).');return false;}
 if(!Number.isFinite(state.L)||!Number.isFinite(state.W)||state.L<10||state.W<10||state.L>400||state.W>400){showError('Les dimensions doivent être comprises entre 10 et 400 mm.');return false;}
 if(state.shape==='libre'&&!state.libreDesc.trim()){showError('Décrivez la forme libre souhaitée.');return false;}
 showError('');return true;
}
function validateContact(){
 for(const id of ['ctNom','ctEmail']){const el=byId(id);if(!el.checkValidity()||!el.value.trim()){goStep(3);el.reportValidity();el.focus();showError('Renseignez votre nom et une adresse e-mail valide.');return false;}}
 return true;
}
function goStep(step){
 if(step>currentStep&&!validateConfiguration())return;
 if(step>=3&&step>currentStep&&!state.visualMode){if(currentStep!==2)goStep(2);showError('Indiquez d’abord où en est votre visuel (A, B, C ou D).');const f=root.querySelector('input[name="fxVisualMode"]');if(f)f.focus();return;}
 const changed=step!==currentStep;
 currentStep=step;
 root.querySelectorAll('[data-goto]').forEach(x=>x.closest('li').classList.toggle('is-done',Number(x.dataset.goto)<step));
 root.dataset.step=String(step);
 setDetail(false);
 if(changed) scrollToTop();
 root.querySelectorAll('[data-stage]').forEach(x=>x.hidden=Number(x.dataset.stage)!==step);
 root.querySelectorAll('[data-goto]').forEach(x=>{if(Number(x.dataset.goto)===step)x.setAttribute('aria-current','step');else x.removeAttribute('aria-current');});
 byId('fxBack').hidden=step===1;byId('fxNext').hidden=step===3;
 byId('fxNext').textContent=step===1?'Continuer vers mon visuel →':'Continuer vers ma demande →';
 showError('');
}
function syncPreview(){
 // Keep shape controls in sync when switching between UV and other materials.
 byId('sizeLibreDesc').style.display = state.shape==='libre' && state.type!=='uv' ? 'block' : 'none';
 root.querySelectorAll('#shapeTiles [data-shape]').forEach(x=>x.classList.toggle('active',x.dataset.shape===state.shape));
 // Circle and square dimensions stay equal. UV formats are set by their own controls.
 if(['rond','carre'].includes(state.shape)&&state.type!=='uv'){state.W=state.L;byId('tailleW').value=state.L||'';}
 byId('tailleW').disabled=['rond','carre'].includes(state.shape);
 root.querySelectorAll('.type-tile,.shape-tile').forEach(x=>x.setAttribute('aria-pressed',String(x.classList.contains('active'))));
 byId('fxSummary').textContent=[typeLabels[state.type],shapeLabels[state.shape],sizeLabel(),'Velcro inclus'].join(' · ');
}
root.querySelectorAll('[data-goto]').forEach(x=>x.addEventListener('click',()=>goStep(Number(x.dataset.goto))));
root.querySelectorAll('[data-face]').forEach(x=>x.addEventListener('click',()=>{face=x.dataset.face;root.querySelectorAll('[data-face]').forEach(b=>b.setAttribute('aria-pressed',String(b===x)));syncPreview();}));
byId('fxBack').addEventListener('click',()=>goStep(currentStep-1));byId('fxNext').addEventListener('click',()=>goStep(currentStep+1));
byId('dropzone').addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();byId('fileInput').click();}});

// --- Améliorations visuelles : remontée de page, aperçu, quantité, détail mobile, avion ---
function headerOffset(){
 let h=0;
 window.document.querySelectorAll('header,sticky-header,.header-wrapper,.shopify-section-header-sticky,[class*="header-group"]').forEach(el=>{
  const cs=getComputedStyle(el);const r=el.getBoundingClientRect();
  if((cs.position==='sticky'||cs.position==='fixed')&&r.top<=1&&r.bottom>h&&r.bottom<window.innerHeight/2)h=r.bottom;
 });
 return h;
}
function scrollToTop(){
 const target=root.querySelector('.fxc-top')||root;
 const y=target.getBoundingClientRect().top+window.pageYOffset-headerOffset()-16;
 const reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 window.scrollTo({top:Math.max(0,y),behavior:reduce?'auto':'smooth'});
}
function renderPatch(){
 const box=byId('fxPatch');if(!box)return;
 const L=state.L>0?state.L:85,W=state.W>0?state.W:85;
 const VW=260,VH=170,MAXW=164,MAXH=86,cx=124,cy=66;
 const k=Math.min(MAXW/L,MAXH/W);const w=L*k,h=W*k;const x=cx-w/2,y=cy-h/2;
 let shape;
 if(state.shape==='rond'){shape='<ellipse cx="'+cx+'" cy="'+cy+'" rx="'+(w/2)+'" ry="'+(h/2)+'"/>';}
 else if(state.shape==='ecu'){shape='<path d="M'+x+' '+y+'H'+(x+w)+'V'+(y+h*0.5)+'C'+(x+w)+' '+(y+h*0.82)+' '+(cx+w*0.18)+' '+(y+h*0.95)+' '+cx+' '+(y+h)+'C'+(cx-w*0.18)+' '+(y+h*0.95)+' '+x+' '+(y+h*0.82)+' '+x+' '+(y+h*0.5)+'Z"/>';}
 else if(state.shape==='libre'){shape='<path d="M'+(x+w*0.18)+' '+(y+h*0.1)+'C'+(x+w*0.45)+' '+(y-h*0.06)+' '+(x+w*0.95)+' '+(y+h*0.02)+' '+(x+w)+' '+(y+h*0.38)+'C'+(x+w*1.04)+' '+(y+h*0.72)+' '+(x+w*0.72)+' '+(y+h)+' '+(x+w*0.42)+' '+(y+h*0.98)+'C'+(x+w*0.1)+' '+(y+h*0.96)+' '+(x-w*0.04)+' '+(y+h*0.66)+' '+x+' '+(y+h*0.42)+'C'+(x+w*0.02)+' '+(y+h*0.24)+' '+(x+w*0.08)+' '+(y+h*0.14)+' '+(x+w*0.18)+' '+(y+h*0.1)+'Z"/>';}
 else {const r=state.shape==='carre'?Math.min(w,h)*0.08:6;shape='<rect x="'+x+'" y="'+y+'" width="'+w+'" height="'+h+'" rx="'+r+'"/>';}
 const id='fxbp'+thisId;
 const img=state.previewUrl?'<clipPath id="'+id+'">'+shape+'</clipPath><image href="'+state.previewUrl+'" x="'+x+'" y="'+y+'" width="'+w+'" height="'+h+'" preserveAspectRatio="xMidYMid slice" clip-path="url(#'+id+')"/>':'';
 const yd=y+h+14,xd=x+w+14;
 const dims='<g class="bp-dim"><path d="M'+x+' '+(yd-5)+'v10M'+(x+w)+' '+(yd-5)+'v10M'+x+' '+yd+'H'+(x+w)+'"/><text x="'+cx+'" y="'+(yd+13)+'" text-anchor="middle">'+L+' mm</text><path d="M'+(xd-5)+' '+y+'h10M'+(xd-5)+' '+(y+h)+'h10M'+xd+' '+y+'V'+(y+h)+'"/><text x="'+(xd+8)+'" y="'+(cy+4)+'">'+W+' mm</text></g>';
 const cross='<g class="bp-cross"><path d="M'+(cx-6)+' '+cy+'h12M'+cx+' '+(cy-6)+'v12"/></g>';
 box.innerHTML='<svg viewBox="0 0 '+VW+' '+VH+'" role="img" aria-label="Schéma : '+shapeLabels[state.shape]+' '+L+' × '+W+' mm">'+img+'<g class="bp-shape'+(state.previewUrl?' has-img':'')+'">'+shape+'</g>'+(state.type==='brode'||state.type==='tisse'?'<g class="bp-border">'+shape+'</g>':'')+(state.previewUrl?'':cross)+dims+'</svg>';
 box.dataset.shape=state.shape;box.dataset.type=state.type;
 const ref=byId('fxBpRef');if(ref)ref.textContent=typeLabels[state.type]+' · '+shapeLabels[state.shape]+' · '+L+'×'+W+' mm';
 const hint=byId('fxLinkHint');if(hint)hint.hidden=!['rond','carre'].includes(state.shape);
 root.querySelectorAll('[data-qty-pick]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.qtyPick)===state.qty)));
}
function setQty(v){
 const input=byId('qtyCustom');input.value=v;input.dispatchEvent(new Event('input',{bubbles:true}));
}
root.querySelectorAll('[data-qty-step]').forEach(b=>b.addEventListener('click',()=>{
 const min=minQtyFor();const cur=parseInt(byId('qtyCustom').value,10);
 setQty(Number.isFinite(cur)?Math.max(min,cur+Number(b.dataset.qtyStep)):min);
}));
root.querySelectorAll('[data-qty-pick]').forEach(b=>b.addEventListener('click',()=>setQty(Number(b.dataset.qtyPick))));
function setDetail(open){
 const t=byId('fxDetailToggle');if(!t)return;
 byId('fxSidebar').classList.toggle('is-open',open);t.setAttribute('aria-expanded',String(open));
 t.firstChild.textContent=open?'Masquer le détail ':'Voir le détail ';
}
byId('fxDetailToggle').addEventListener('click',()=>setDetail(byId('fxDetailToggle').getAttribute('aria-expanded')!=='true'));
function flyPlane(btn){
 const icon=btn.querySelector('.fxc-plane');if(!icon)return;
 const reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 const r=icon.getBoundingClientRect();
 btn.classList.add('is-flown');
 if(reduce||!icon.animate||!r.width)return;
 const ghost=icon.cloneNode(true);ghost.classList.add('fxc-plane-ghost');
 Object.assign(ghost.style,{position:'fixed',left:r.left+'px',top:r.top+'px',width:r.width+'px',height:r.height+'px',zIndex:9999,pointerEvents:'none',margin:0});
 window.document.body.append(ghost);
 const dx=Math.min(window.innerWidth-r.left+60,560),dy=-Math.min(r.top+80,440);
 const anim=ghost.animate([
  {transform:'translate(0,0) rotate(0deg) scale(1)',opacity:1},
  {transform:'translate(-12px,8px) rotate(-6deg) scale(1.05)',opacity:1,offset:.15},
  {transform:'translate('+(dx*.35)+'px,'+(dy*.12)+'px) rotate(-14deg) scale(1.4)',opacity:1,offset:.45},
  {transform:'translate('+dx+'px,'+dy+'px) rotate(-30deg) scale(.6)',opacity:0}
 ],{duration:1400,easing:'cubic-bezier(.45,0,.25,1)',fill:'forwards'});
 anim.onfinish=()=>ghost.remove();
 for(let i=1;i<=8;i++){
  const t=i/8;const p=window.document.createElement('span');p.className='fxc-trail';
  Object.assign(p.style,{left:(r.left+r.width/2-3)+'px',top:(r.top+r.height/2-3)+'px'});
  window.document.body.append(p);
  const x=dx*.35*t,y=dy*.12*t*t;
  p.animate([{opacity:0,transform:'translate('+x+'px,'+y+'px) scale(.3)'},{opacity:.75,transform:'translate('+x+'px,'+y+'px) scale(1)',offset:.25},{opacity:0,transform:'translate('+(x-6)+'px,'+(y+8)+'px) scale(.2)'}],{duration:800,delay:180+i*55,easing:'ease-out',fill:'both'}).onfinish=()=>p.remove();
 }
}

const requestedType=new URLSearchParams(window.location.search).get('type');
const initial=['brode','tisse','pvc','laser','uv'].includes(requestedType)?requestedType:'pvc';
root.querySelector('[data-type="'+initial+'"]').click();
update();

}}customElements.define('foxinnov-configurator',FoxConfigurator);})();
/* fxDefaultQty : estimation affichée dès l'arrivée */
(function(){function run(){var q=document.getElementById('qtyCustom');if(q&&q.value){q.dispatchEvent(new Event('input',{bubbles:true}));}}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}})();
